module.exports = __webpack_public_path__ + "static/assets/fecb6a6b3671bb596526856e413bb62c.svg";